/// <amd-module name="VSSUI/Components/EditableDropdown/EditableDropdown" />
import * as React from "react";
import { ObservableLike, ObservableValue } from "VSS/Core/Observable";
import { IExpandable } from "VSSUI/Expandable";
import { IListBoxItem } from "VSSUI/ListBox";
import { IFocusable } from "VSSUI/Utilities/Focus";
import { CustomEditableDropdown } from "./CustomEditableDropdown";
import { IEditableDropdownProps } from "./EditableDropdown.Props";

export class EditableDropdown<T = {}> extends React.Component<IEditableDropdownProps<T>> implements IExpandable, IFocusable<{}> {
    private text: ObservableValue<string>;
    private selectedText: ObservableValue<string>;
    private dropdown = React.createRef<CustomEditableDropdown>();

    public constructor(props: IEditableDropdownProps<T>) {
        super(props);

        this.text = ObservableLike.isObservable(props.text)
            ? (props.text as ObservableValue<string>)
            : new ObservableValue<string>((props.text as string) || "");
        this.selectedText = ObservableLike.isObservable(props.selectedText)
            ? (props.selectedText as ObservableValue<string>)
            : new ObservableValue<string>(props.selectedText as string);
    }

    public collapse = (): void => {
        if (this.dropdown.current) {
            this.dropdown.current.collapse();
        }
    };

    public expand = (): void => {
        if (this.dropdown.current) {
            this.dropdown.current.expand();
        }
    };

    public focus() {
        if (this.dropdown.current) {
            this.dropdown.current.focus();
        }
    }

    public render() {
        return (
            <CustomEditableDropdown
                {...this.props}
                onExpand={this.onExpand}
                onTextChange={this.onTextChange}
                onValueChange={this.onValueChange}
                ref={this.dropdown}
                selectedText={this.selectedText}
                text={this.text}
            />
        );
    }

    private onExpand = () => {
        const { allowTextSelection, onExpand } = this.props;
        if (onExpand) {
            onExpand();
        }

        if (allowTextSelection) {
            this.text.value = this.selectedText.value;
        }
    };

    private onTextChange = (
        event: React.SyntheticEvent<HTMLElement, Event> | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | null,
        value: string
    ) => {
        if (this.props.onTextChange) {
            this.props.onTextChange(event, value);
        }
        this.text.value = value;
    };

    private onValueChange = (value?: IListBoxItem<T>) => {
        if (this.props.onValueChange) {
            this.props.onValueChange(value);
        }
        this.selectedText.value = (value && value.text) || "";
    };
}
